import {
  IAddressDataObject,
  IFindCallerObject,
  IInputsCoverageTool,
  IInvoiceObject,
  IPersonalDataObject,
  IPickUpLocation,
} from '@vfit/shared/models';
import {
  IContactInfo,
  IConsentsObject,
  ITermsAndConditionsCheck,
  IUpfrontSelection,
  IUpdateProductPriceControl,
  IPortabilityObject,
  IPortabilityStatus,
  IAddonState,
  CheckoutStepState,
  CheckoutStepperState,
} from './Checkout/checkout.models';
//import { OPTION_TO_RECONSIDER_FROM_CMS } from './iBuyFixed.utils';
import { IUseCustomerDeliveryBaseResponse } from './Checkout/hooks/UseCustomerDeliveryBase/useCustomerDeliveryBase.models';
import { IUseCustomerAsyncInformationResponse } from './Checkout/hooks/UseCustomerAsyncInformation/useCustomerAsyncInformation.models';
import { IUseAuthorizationAsyncInformationResponse } from './Checkout/hooks/UseAuthorizationAsyncInformation/useAuthorizationAsyncInformation.models';
import { IUseCustomerResponse } from './Checkout/hooks/UseCustomerFlow/useCustomerFlow.models';
import { IUseVoucherDiscountResponse } from './Checkout/hooks/UseVoucherDiscount/useVoucherDiscount.models';
import { IUseCheckoutErrors } from './Checkout/hooks/UseCheckoutErrors/useCheckoutErrors.models';
import { IUseAuthorizeFlow } from './Checkout/hooks/UseAuhorizeFlow/useAuthorizeFlow.models';
import { IUseLockInMMFlowResponse } from './Checkout/hooks/UseLockInMMFlow/useLockInMMFlow.models';
import { IUseLockInAppFlowResponse } from './Checkout/hooks/UseLockInAppFlow/useLockInAppFlow.models';
import { IUseLockInFlowResponse } from './Checkout/hooks/UseLockInFlow/useLockInFlow.models';
import { IUseAuthorizeAuthorizationFlowResponse } from './Checkout/hooks/UseAuthorizeAuthorizationFlow/useAuthorizeAuthorizationFlow.models';
import { CHECKOUT_STEP_CONFIG } from './Checkout/checkout.constants';

export const CONTEXT_KEY = 'ctxk';

export const DEFAULT_CUSTOMER_ID = '';

export const DEFAULT_DATA: IPersonalDataObject = {
  owningIndividual: {
    nation: '',
    fiscalCode: '',
    firstName: '',
    lastName: '',
    contactMedium: [
      {
        type: 'email',
        preferred: true,
        emailAddress: '',
      },
      { type: 'phone', preferred: false, phoneNumber: '' },
    ],
    identification: [
      {
        identificationType: '',
        nationality: '',
        identificationNumber: '',
        expirationDate: '',
      },
    ],
  },
  isValid: false,
  isLogged: false,
};

export const DEFAULT_CONTACT_INFO: IContactInfo = {
  checkContactProblem: true,
};
export const DEFAULT_PORTABILITY_MIGRATION = {
  firstOperator: '',
  firstCode: '',
  firstCodeValid: false,
  secondOperator: '',
  secondCode: '',
  secondCodeValid: false,
  noCode: false,
};

export const DEFAULT_PORTABILITY: IPortabilityObject = {
  portabilityNumber: '',
  portabilityWant: undefined,
  portabilityMigration: {
    currentProvider: '',
    currentPlan: '',
    transferBalance: false,
  },
};

export const DEFAULT_PORTABILITY_STATUS: IPortabilityStatus = {
  isStartPortIn: false,
  isLoadingCheck: false,
  isSuccessCheck: false,
  isErrorCheck: false,
  isStartFinalPortIn: false,
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const DEFAULT_ADDON_STATE: IAddonState = {
  addonCmsId: '',
  addonMecId: '',
  availableAddons: [],
  callGetAddons: false,
  callSaveAddon: false,
  callRemoveAddon: false,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isLoadingUpdate: false,
  isLoadingPriceUpdate: false,
  errorMessage: '',
};

export const DEFAULT_CONSENTS: IConsentsObject = {
  partyPrivacyItems: [],
};

export const DEFAULT_BILLING_ADDRESS: IAddressDataObject = {
  city: '',
  postalCode: '',
  stateOrProvince: '',
  street: '',
  streetNumber: '',
  href: '',
  id: '',
  country: '',
  displayCountry: '',
  formattedAddress: '',
  formattedAddress1: '',
  addressStatus: '',
  externalId: '',
  homeZone: '',
  istatCode: '',
};

export const DEFAULT_INSTALLATION_ADDRESS: IAddressDataObject = {
  city: '',
  postalCode: '',
  stateOrProvince: '',
  street: '',
  streetNumber: '',
  href: '',
  id: '',
  country: '',
  displayCountry: '',
  formattedAddress: '',
  formattedAddress1: '',
  addressStatus: '',
  externalId: '',
  homeZone: '',
  istatCode: '',
};

export const DEFAULT_SHIPPING_ADDRESS: IAddressDataObject = {
  city: '',
  postalCode: '',
  stateOrProvince: '',
  street: '',
  streetNumber: '',
  href: '',
  id: '',
  country: '',
  displayCountry: '',
  formattedAddress: '',
  formattedAddress1: '',
  addressStatus: '',
  externalId: '',
  homeZone: '',
  istatCode: '',
};

export const DEFAULT_FIND_CALLER: IFindCallerObject = {
  activeSimMobile: false,
  individualRef: {
    msisdn: '',
    email: '',
  },
  selectedContactMedium: {
    field: '',
    fieldType: '',
  },
  showOtp: false,
  verifyOtp: '',
  customerHasActiveSubs: false,
};

export const DEFAULT_LAST_CARD = false;

export const DEFAULT_IS_FLOW_READY = false;

export const DEFAULT_TERMS_AND_CONDITIONS: ITermsAndConditionsCheck = {
  consensus: false,
  optionToReconsider: 'no',
  isSuccessTermsAndConditions: false,
  isLoadingTermsAndConditions: false,
  isErrorTermsAndConditions: false,
};

export const DEFAULT_INVOICE: IInvoiceObject = {
  option: '',
};

export const DEFAULT_UPFRONT_SELECTION: IUpfrontSelection = {
  option: '',
};

export const DEFAULT_SLIDES_GO_BACK = -1;

export const DEFAULT_ADDRESS: IInputsCoverageTool = {
  placeId: '',
  city: '',
  postalCode: '',
  stateOrProvince: '',
  street: '',
  streetNumber: '',
};

export const DEFAULT_DELIVERY_BASE = {
  isSuccess: false,
  isLoading: false,
  isError: false,
  errorMessage: '',
  deliveryOptions: [],
  identificationDetails: [],
};

export const DEFAULT_DELIVERY_ADVANCE = {
  isSuccess: false,
  isLoading: false,
  isError: false,
  deliveryOptions: [],
  identificationDetails: [],
};

export const DEFAULT_PICKUP_POINT: IPickUpLocation = {
  storeId: '',
  locationAddress: {
    id: '',
    city: '',
    country: '',
    displayCountry: '',
    stateOrProvince: '',
    displayStateOrProvince: '',
    longitude: '',
    latitude: '',
    postalCode: '',
    formattedAddress1: '',
    postalOfficeID: '',
    postalOfficeDescription: '',
  },
  aerialDistance: 1.521,
};

export const DEFAULT_TIMER_ID = undefined;

export const DEFAULT_IS_DISABLED_BACK_BUTTON = false;

export const DEFAULT_KEEPS_NUMBER = undefined;

export const DEFAULT_IS_VALID_NUMBER_PORTABILITY = false;

export const DEFAULT_WINBACK_NUMBER = '';

export const DEFAULT_OFFER_ID = '';

export const DEFAULT_UPDATE_PRODUCT_PRICE: IUpdateProductPriceControl = {
  isUpdatePrice: false,
  isPriceUpdated: true,
};

export const DEFAULT_PICKUP_LOCATION_STORE = {
  startDeliveryLocateAndPickupPoint: () => {},
  global: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  searchPickupLocations: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  searchPostalOffice: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  searchLocateStore: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
};

export const DEFAULT_BILLING_REPLACE = {
  validateAddress: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  createAddress: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  replaceAddress: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  billDelivery: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
};

export const DEFAULT_CART_ASYNC_INFO = {};

export const DEFAULT_CUSTOMER_DELIVERY_BASE_INFO: IUseCustomerDeliveryBaseResponse = {
  deliveryBase: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    identificationDetails: [],
    deliveryOptions: [],
    errorMessage: '',
  },
};

export const DEFAULT_CUSTOMER_ASYNC_INFO: IUseCustomerAsyncInformationResponse = {
  retrieveMultilines: { isLoading: false, isSuccess: false, isError: false },
  termsAndConditions: { isLoading: false, isSuccess: false, isError: false },
  customerInfo: { isLoading: false, isSuccess: false, isError: false, data: undefined },
};

export const DEFAULT_AUTHORIZATION_ASYNC_INFO: IUseAuthorizationAsyncInformationResponse = {
  authorization: { isLoading: false, isSuccess: false, isError: false },
  payMean: { isLoading: false, isSuccess: false, isError: false },
};

export const DEFAULT_CUSTOMER_FLOW: IUseCustomerResponse = {
  findcaller: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  updateProductChatacteristics: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  patchCustomer: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  postCustomer: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  associateCustomer: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  billingAccount: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  paymean: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  payment: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  customerInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  resetPatchAndPost: () => {},
};

export const DEFAULT_CHECKOUT_ERRORS: IUseCheckoutErrors = {};

export const DEFAULT_VOUCHER_DISCOUNT: IUseVoucherDiscountResponse = {
  voucherId: '',
  bo_array: [],
  isApplyVoucher: false,
  isAppliedVoucher: false,
  validateVoucher: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  voucher: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  shoppingCart: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
};

export const DEFAULT_AUTHORIZE_FLOW: IUseAuthorizeFlow = {
  isStartAuthorizeFlow: false,
  authorizationOperationMethod: 'capture',
  selectedMethod: undefined,
  authorize: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
  },
};

export const DEFAULT_LOCKIN_FLOW: IUseLockInFlowResponse = {
  campaigns: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  accept: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  shoppingCart: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  associateCustomer: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
};

export const DEFAULT_LOCKIN_MM_FLOW: IUseLockInMMFlowResponse = {
  campaigns: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  accept: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  shoppingCart: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  checkEligibility: {
    eligible: false,
  },
};

export const DEFAULT_LOCKIN_APP_FLOW: IUseLockInAppFlowResponse = {
  campaigns: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  accept: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  shoppingCart: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: undefined,
    error: undefined,
  },
  checkEligibility: {
    eligible: false,
  },
};

export const DEFAULT_AUTHORIZE_AUTHORIZATION_FLOW: IUseAuthorizeAuthorizationFlowResponse = {
  authorize: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: undefined,
  },
};

export const DEFAULT_IS_START_RECOGNITION = false;

export const DEFAULT_IS_START_DELIVERY_BASE = false;

export const DEFAULT_IS_NEW_ADDRESS = false;

export const DEFAULT_IS_START_AUTHORIZATION_ASYNC_INFO = false;

export const DEFAULT_IS_START_CUSTOMER_FLOW = false;

export const DEFAULT_IS_START_LOCKIN_MM_FLOW = false;

export const DEFAULT_IS_START_LOCKIN_FLOW = false;

export const DEFAULT_IS_START_LOCKIN_APP_FLOW = false;

export const DEFAULT_PRODUCT = {};

export const DEFAULT_IS_SHOW_CHECKOUT = false;

export const DEFAULT_BILLING_EMAIL = '';

export const DEFAULT_CHECKOUT_STEPS: CheckoutStepperState = CHECKOUT_STEP_CONFIG.reduce(
  (acc, step) => {
    acc[step.key] = {
      visited: 0,
      hidden: false,
      completed: false,
    };
    return acc;
  },
  {} as CheckoutStepperState,
);

